import * as React from "react";
import { toast } from "react-toastify";
import { LicensePlateLookupUtils } from "./Utils/LicensePlateLookupUtils";
import store from "../../../../store/Store";
import rootReducer from "../../../../store/Reducers";
import * as urls from "../../../shared/urls";

interface ILicensePlateProps {
    component: any;
    form: any;
    onChange: () => void;
    isValid: boolean;
    value: string;
}

interface ILicensePlateState {
    value: string;
    url: string;
    isValid: boolean;
    shouldFocus: boolean;
    hasUserEdited: boolean;
}

const licensePlateRequest = {
    VIN: "",
    VehicleDataRequest: true,
    RegistrationDataRequest: true,
    VehicleIDRequest: true,
    PlateNumber: ""
};

const reduxStore = store({}, rootReducer);
const { LICENSE_PLATE_VALIDATION_URL } = urls;

export default class LicensePlateLookupComponentReact extends React.Component<ILicensePlateProps, ILicensePlateState> {
    private textInputRef: HTMLInputElement;
    state: ILicensePlateState = {
        url: "",
        value: this.props.value,
        isValid: this.props.isValid,
        shouldFocus: false,
        hasUserEdited: false
    };


    componentDidUpdate(prevProps: ILicensePlateProps, prevState: ILicensePlateState) {
        if (this.state.shouldFocus) {
            this.textInputRef.focus();
            this.setState({ shouldFocus: false });
        }

        if (prevProps.value !== this.props.value && this.props.value !== this.state.value) {
            this.setState({ value: this.props.value, hasUserEdited: false });
        }

        if (prevState.value != this.state.value) {
            this.props.onChange();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !(this.state.shouldFocus == true && nextState.shouldFocus == false);
    }


    executeLicensePlateSearch = (rawValue: string) => {
        const backendUrl = reduxStore.getState().valueOf();
        const object = backendUrl.valueOf();
        const url = object["Application"];
        this.state.url = url["backendURL"];
        licensePlateRequest.VIN = "";
        licensePlateRequest.PlateNumber = (rawValue || "").trim();
        if (!licensePlateRequest.PlateNumber) {
            return;
        }

        this.setState({ hasUserEdited: false });

        const licensePlateInfo = LicensePlateLookupUtils.LicensePlateSearch(licensePlateRequest, this.state.url + LICENSE_PLATE_VALIDATION_URL);

        licensePlateInfo.then(data => {
            if (!data) {
                return;
            }

            LicensePlateLookupUtils.ProcessLicensePlate(data, this.props.component, this.props.form);
        });
        console.log('test1: ', this.props.component, this.props.form)
    };

    searchLicensePlate = e => {
        if (!this.state.hasUserEdited) {
            return;
        }

        this.executeLicensePlateSearch(e?.target?.value);
    };

    onKeyDown = e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            this.executeLicensePlateSearch(e?.target?.value);
        }
    };

    onChange = e => {
        this.setState({ value: e.target.value, hasUserEdited: true });
    };

    focus = () => {
        this.setState({ shouldFocus: true });
    };

    render() {
        const { component } = this.props;

        let className = component.customClass + (component.inputClass && component.inputClass.length ? component.inputClass : "form-control");
        className = this.state.isValid ? className : className + " is-invalid";

        return (
            <div>
                <input
                    type="text"
                    className={className}
                    placeholder={component.placeholder}
                    title={component.tooltip}
                    tabIndex={component.tabIndex}
                    onBlur={this.searchLicensePlate}
                    onKeyDown={this.onKeyDown}
                    onChange={this.onChange}
                    value={this.state.value}
                    ref={element => {
                        this.textInputRef = element;
                    }}
                />
            </div>
        );
    }
}
